import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import { Spacer } from '../layout';

type NavbarProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isMobile?: boolean;
  navbarBody?: React.ReactNode;
  footerNode?: React.ReactNode;
  closeIcon?: React.ReactNode;
  logo?: React.ReactNode;
};

const NavBar: React.FC<NavbarProps> = ({
  isOpen,
  setIsOpen,
  isMobile = false,
  navbarBody,
  footerNode,
  closeIcon,
  logo,
}) =>
  isOpen ? (
    <Drawer
      navbar={'default'}
      open={isOpen}
      variant={isMobile ? 'temporary' : 'persistent'}
      onClose={() => setIsOpen(false)}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {isMobile && (
          <Box
            onClick={() => setIsOpen(false)}
            sx={{ display: 'flex', alignSelf: 'flex-end', cursor: 'pointer' }}
          >
            {closeIcon}
          </Box>
        )}
        <Spacer height="2.5rem" />
        <Link href="/">{logo}</Link>
        <Box component={List} sx={{ display: 'flex', flexDirection: 'column' }}>
          {navbarBody}
          <Spacer height="3.5rem" />
        </Box>
      </Box>

      {footerNode || (
        <Button LinkComponent={Link} href="/auth/signout" fullWidth>
          Logout
        </Button>
      )}
    </Drawer>
  ) : null;

export default NavBar;
